/* eslint-disable */

/**
 * 该文件为脚本自动生成文件，请勿随意修改。如需修改请联系 PMC
 * */

import { TdTitleProps } from './type';
const props: TdTitleProps = {
  /** 段落内容 */
  content: {
    type: String,
  },
  /** 是否省略展示，可通过配置参数自定义省略操作的具体功能和样式 */
  ellipsis: {
    type: null,
    value: false,
  },
  /** 标题等级 */
  level: {
    type: String,
    value: 'h1',
  },
};

export default props;
